import { createDropdown } from "./createDropdown";

export const Dropdown = createDropdown({});
